import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Banner from "./components/Banner";
import PricingCards from "./components/Pricing";
import Testomonials from "../../components/testomonials";
import RetailAvailability from "./components/RetailAvailibilty";
import ClinicalStudies from "../../components/Studies";
import Stop from "../../assets/landingPage/stopNew.png";
import ClickBank from "../../components/Footer";
import { LOADER_STATUS } from "../../constant/Data";

function U1() {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);
  const [startTimer, setStartTimer] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(false);

  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);

      // Check if there is any query parameter
      const hasAnyParam = Array.from(params.entries()).length > 0;

      setIsVideoParamExists(hasAnyParam);

      setIsShowVsl(1);
    }
  }, [location]);

  const maximizeVideo = () => {
    setIsVideoPlay(LOADER_STATUS.PLAY);

    // console.log("Maximize Video", "LOADER", isVideoPlay);
    setIsVideoPlay(LOADER_STATUS.PLAY);
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.maxWidth = "100%";
    video.style.height = "100vh";
    video.style.padding = "0px";
    video.style.backgroundColor = "#000";

    vidwrapper.style.height = "100vh";
    vidwrapper.style.width = "100%";
    vidwrappervid.style.height = "100vh";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "contain";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "contain";
    }
  };

  const minimizeVideo = () => {
    // console.log("Minimize Video");
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.padding = "20px";
    video.style.maxWidth = "900px";
    video.style.height = "480px";
    video.style.backgroundColor = "transparent";

    vidwrapper.style.height = "100%";
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = "100%";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "cover";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "cover";
    }
  };

  useEffect(() => {
    const SECONDS_TO_DISPLAY = 382;
    let attempts = 0;
    let elsDisplayed = false;

    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true);
      localStorage.setItem(alreadyDisplayedKey, true);

      const player = window.smartplayer.instances?.[0];
      const currentTime = player?.video?.currentTime;
      // console.log(`CTA dropped at Current video time: ${currentTime}`);
    };

    const startWatchVideoProgress = () => {
      if (
        typeof window.smartplayer === "undefined" ||
        !(window.smartplayer.instances && window.smartplayer.instances.length)
      ) {
        if (attempts >= 10) return;
        attempts += 1;
        return setTimeout(() => {
          startWatchVideoProgress();
        }, 1000);
      }
      const player = window.smartplayer.instances[0];
      player.on("timeupdate", () => {
        if (player.smartAutoPlay === false) {
          setIsVideoPlay(LOADER_STATUS.PLAY);
          maximizeVideo();
        }

        if (elsDisplayed || player.smartAutoPlay) return;
        const currentTime = player.video.currentTime;
        // console.log("Current video time:", currentTime);

        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements();
      });

      player.on("pause", () => {
        setIsVideoPlay(LOADER_STATUS.PAUSE);
        minimizeVideo();
      });
    };

    if (alreadyElsDisplayed === "true") {
      setTimeout(() => {
        showHiddenElements();
      }, 100);
    } else {
      startWatchVideoProgress();
    }
  }, []);

  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);

  const skipVideoAndShowCTA = () => {
    const video = document.querySelector("video");
    if (video) {
      video.currentTime = 382;
      video.dispatchEvent(new Event("timeupdate"));
    }
    setIsVisible(true);
  };

  return (
    <>
      <Helmet>
        {/* VisiSmart Code - DO NOT MODIFY */}
        <script async type="text/javascript">
          {`
      <script async type='text/javascript'>window.visiopt_code=window.visiopt_code||(function(){var visi_wid=1001,visi_pid=99,visi_flicker_time=4000,visi_flicker_element='html',c=false,d=document,visi_fn={begin:function(){var a=d.getElementById('visi_flicker');if(!a){var a=d.createElement('style'),b=visi_flicker_element?visi_flicker_element+'{opacity:0!important;background:none!important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','visi_flicker');a.setAttribute('type','text/css');if(a.styleSheet){a.styleSheet.cssText=b;}else{a.appendChild(d.createTextNode(b));}h.appendChild(a);}},complete:function(){c=true;var a=d.getElementById('visi_flicker');if(a){a.parentNode.removeChild(a);}},completed:function(){return c;},pack:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){visi_fn.complete();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){visi_fn.begin();setTimeout(function(){visi_fn.complete()},visi_flicker_time);this.pack('https://visiopt.com/client/js_test/test.'+visi_wid+'.'+visi_pid+'.js');return true;}};window.visiopt_code_status=visi_fn.init();return visi_fn;}());</script>
      `}
        </script>
        {/* End Of VisiSmart Code */}
      </Helmet>
      {isVideoParamExists !== null && (
        <div className="w-full">
          {isVideoParamExists ? (
            <>
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY ? "hidden" : "w-full"
                }
              >
                <div className=" py-[20px]  bg-[#132C4D]  text-center flex flex-col items-center justify-center">
                  <h2 className="text-2xl text-[#fdf651] font-bold leading-[24px] md:mb-[1rem] mb-2">
                    IMPORTANT: Do NOT close this window nor click the “Back”
                    button
                  </h2>
                  <p className="text-[#fdf651] text-2xl font-light md:leading-[10px] leading-[28px]  mb-[1rem]">
                    Clicking “back” button can result in your order being
                    double-billed
                  </p>
                </div>
              </div>
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY
                    ? "w-full"
                    : "max-w-7xl mx-auto"
                }
              >
                <div className={isVideoPlay ? "hidden" : "w-full"}>
                  <div className=" p-3 max-w-7xl text-center flex gap-4 items-center md:flex-row flex-col justify-center leading-normal">
                    <div className="flex items-center">
                      <img src={Stop} alt="stop " />
                      <h2 className="text-[80px] md:text-[90px] font-bold text-[#dc252c] leading-[normal]">
                        WAIT
                      </h2>
                    </div>
                    <div className="space-y-1 px-3">
                      <h2 className=" text-[28px] md:text-[30px] font-bold underline text-[#132C4D] leading-none">
                        Your Order Is Not Complete Yet
                      </h2>
                      <div className="bg-[#EFEE53] text-[#132c4d] md:px-[10px] sm:px-2 py-[1.5px] md:text-[20px] text-[18px] font-light leading-normal">
                        Please Watch This Important Message Below Now
                      </div>
                    </div>
                  </div>
                </div>
                {/* //   Dynamically embed the player script */}
                <div className="w-full flex items-center justify-center">
                  <div
                    // className={isVideoPlay ? 'w-full' : "md:w-[70%] w-[90%]"}
                    className={
                      isVideoPlay === LOADER_STATUS.PLAY
                        ? "w-full"
                        : "md:w-[70%] w-[90%]"
                    }
                    dangerouslySetInnerHTML={{
                      __html: `
            <script type="text/javascript"  id="scr_680bca9675775e9776e414ae"></script>
          `,
                    }}
                  />

                  {/* Helmet to inject the video player script into the head */}
                  <Helmet>
                    <script type="text/javascript">
                      {`   var s=document.createElement("script");
                      s.src="https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/680bca9675775e9776e414ae/player.js",
                       s.async=!0,
                       document.head.appendChild(s);`}
                    </script>
                  </Helmet>
                </div>

                <div
                  id="smartplayer"
                  style={{
                    width: "100%",
                    position: "relative",
                    padding: "0",
                  }}
                ></div>

                <div className=" pt-6  p-3 max-w-7xl mx-auto text-center flex flex-col items-center justify-center pb-16">
                  <h3 className="md:text-[22px] text-[20px] max-w-[800px] text-[#000] font-semibold leading-[24px]">
                    <strong className="text-red-600 text-[24px] font-[700]">
                      DO THIS FIRST:
                    </strong>{" "}
                    Please watch this important New Member update right now.
                    Your order and access link to your bonuses will appear here
                    at the end of the video.
                  </h3>
                </div>
              </div>
              {isVisible && (
                <div
                  className="hide smartplayer-scroll-event"
                  id="hidden-section"
                >
                  <div ref={pricingRef}>
                    <PricingCards isVsl={true} />
                  </div>
                  <Testomonials />
                  <RetailAvailability />
                </div>
              )}
              <ClinicalStudies onClickSkip={skipVideoAndShowCTA} />
            </>
          ) : (
            <>
              <Banner />
              <PricingCards />
              <Testomonials />
              <RetailAvailability />
              <ClinicalStudies />
            </>
          )}
        </div>
      )}
    </>
  );
}

export default U1;
